import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { BlocksModule } from './blocks/blocks.module';
import { AppComponent } from './blocks/root/app.component';
import { RouterModule } from '@angular/router';
import { HTTP_INTERCEPTORS, HttpBackend, HttpClient, HttpClientModule } from '@angular/common/http';
import { HashLocationStrategy, LocationStrategy, registerLocaleData } from '@angular/common';
import { LoadingInterceptor } from './shared/interceptors/loading.interceptor';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AmazonFullPathPipe } from './shared/pips/amazon-full-path.pipe';
import { TranslateLoader, TranslateModule, TranslatePipe, TranslateService, TranslateStore } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { LayoutModule } from '@angular/cdk/layout';
import { KycExpiredDialogComponent } from './shared/components/kyc-expired-dialog/kyc-expired-dialog.component';
import { CorsInterceptor } from './shared/interceptors/cors.interceptor';
import { TenantConfigService } from './shared/services/tenant-config.service';
import { applyTenantTranslations } from './shared/i18n/translations';
import { environment } from 'src/environments/environment';
import { KycHighRiskDialogComponent } from './shared/components/kyc-high-risk-dialog/kyc-high-risk-dialog.component';
import localeAr from '@angular/common/locales/ar-SA';

// Register Arabic locale data for date formatting
registerLocaleData(localeAr, 'ar-SA');

export function initTenantConfig(cfg: TenantConfigService) {
  return () => cfg.loadConfig();
}

@NgModule({
  declarations: [
    AmazonFullPathPipe, KycExpiredDialogComponent, KycHighRiskDialogComponent

  ],
  imports: [
    BlocksModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    RouterModule,
    HttpClientModule,
    LayoutModule,
    NgxSpinnerModule.forRoot({
      type: 'ball-scale-multiple',
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (TranslationLoaderFactory),
        deps: [HttpClient]
      }
    }),
  ],
  providers: [
    TranslateStore,
    {
      'provide': APP_INITIALIZER,
      'useFactory': InitTranslation,
      'deps': [TranslateService],
      'multi': true
    },
    { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: CorsInterceptor, multi: true },
    {
      provide: APP_INITIALIZER,
      useFactory: initTenantConfig,
      deps: [TenantConfigService],
      multi: true
    },
  ],
  bootstrap: [AppComponent]
})

export class AppModule { }

//platformBrowserDynamic().bootstrapModule(AppModule);

export function TranslationLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
export function InitTranslation(translate: TranslateService) {
  return () => {
    const tenantId = 'miyar';

    applyTenantTranslations(translate, tenantId);

    // Check for stored language preference in localStorage
    const storedLang = localStorage.getItem('currentLang');
    const defaultLang = storedLang && (storedLang === 'ar' || storedLang === 'en') ? storedLang : 'en';

    translate.setDefaultLang('en');
    translate.use(defaultLang);

    // Set HTML direction based on stored language
    if (defaultLang === 'ar') {
      document.dir = 'rtl';
      document.body.lang = 'ar';
      document.body.classList.remove('en');
      document.body.classList.add('ar');
    } else {
      document.dir = 'ltr';
      document.body.lang = 'en';
      document.body.classList.remove('ar');
      document.body.classList.add('en');
    }

    return Promise.resolve();
  };
}